var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "actions-panel-dialog-container" },
    [
      _c(
        "header",
        { staticClass: "header" },
        [
          _c("div", { staticClass: "header-title" }, [
            _vm._v(_vm._s(_vm.texts.dialogTitle)),
          ]),
          _c("v-spacer"),
          _c("span", {
            class: [_vm.closeIcon, "close-icon"],
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.closeDialog.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
      _c("LexonTextFieldComponent", {
        attrs: { id: "title", label: _vm.texts.title },
        model: {
          value: _vm.info.subject,
          callback: function ($$v) {
            _vm.$set(_vm.info, "subject", $$v)
          },
          expression: "info.subject",
        },
      }),
      _c("LexonAutocompleteComponent", {
        attrs: {
          "prop-items": _vm.statusOptions,
          clearable: false,
          itemName: "status",
          hasRelatedField: true,
          label: _vm.texts.status,
          attach: false,
        },
        model: {
          value: _vm.info.statusObject,
          callback: function ($$v) {
            _vm.$set(_vm.info, "statusObject", $$v)
          },
          expression: "info.statusObject",
        },
      }),
      _c("LexonAutocompleteComponent", {
        attrs: {
          "prop-items": _vm.responsibles,
          clearable: false,
          itemName: "name",
          hasRelatedField: true,
          label: _vm.texts.responsible,
          attach: false,
        },
        model: {
          value: _vm.info.responsible,
          callback: function ($$v) {
            _vm.$set(_vm.info, "responsible", $$v)
          },
          expression: "info.responsible",
        },
      }),
      _c(
        "div",
        { staticClass: "panel-buttons-container" },
        [
          _c(
            "button",
            {
              staticClass: "secondary-button",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.closeDialog.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.texts.closeDialog))]
          ),
          _c("v-spacer"),
          _c(
            "button",
            {
              staticClass: "secondary-button",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.openAction.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.texts.openNewWindow))]
          ),
          _c(
            "button",
            {
              class: ["main-button", { disabled: _vm.saveButtonIsDisabled }],
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.editAction.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.texts.save))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }